import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

// GET ALL JOB TIME CHECKS (list + filters + pagination)
export const getAllJobTimeChecksAsync = createAsyncThunk(
  "jobTimeCheck/getAllJobTimeChecksAsync",
  async (payload = {}, toolkit) => {
    return await AxiosClient(
      "GET",
      `/jobs/time-check?page=${payload?.page || 1}&limit=${
        payload?.limit || 10
      }&client=${payload?.client || ""}&city=${payload?.city || ""}&state=${
        payload?.state || ""
      }`,
      [],
      toolkit
    );
  }
);

// GET ONE JOB TIME CHECK (includes images[]) - used by the View Images action
export const getJobTimeCheckByIdAsync = createAsyncThunk(
  "jobTimeCheck/getJobTimeCheckByIdAsync",
  async (jobId, toolkit) => {
    return await AxiosClient(
      "GET",
      `/jobs/time-check/${jobId}`,
      [],
      toolkit
    );
  }
);

// ADD a job photo + data (new job if jobId omitted, else appends to
// the existing job's images). multipart/form-data.
export const createJobTimeCheckAsync = createAsyncThunk(
  "jobTimeCheck/createJobTimeCheckAsync",
  async (formData, toolkit) => {
    return await AxiosClient(
      "POST",
      `/jobs/time-check`,
      formData,
      toolkit,
      {},
      "multipart/form-data"
    );
  }
);

// Re-stamp one specific image with a new date/time
export const correctJobTimeCheckImageAsync = createAsyncThunk(
  "jobTimeCheck/correctJobTimeCheckImageAsync",
  async ({ jobId, imageIndex, newJobDate, newJobTime }, toolkit) => {
    return await AxiosClient(
      "POST",
      `/jobs/time-check/${jobId}/images/${imageIndex}/correct-photo`,
      { newJobDate, newJobTime },
      toolkit
    );
  }
);
